export default function VisionQuoteFooter({name, titleDescription}) {
  return (
    <footer className="mt-6">
      <p className="text-base font-medium text-blue-100">{name}</p>
      <div className="text-base font-medium text-blue-300">{titleDescription}</div>
    </footer>
  );
}
